import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import HowToChooseSection from './components/HowToChooseSection';
import ProductShowcase from './components/ProductShowcase';
import TechSection from './components/TechSection';
import MarketsSection from './components/MarketsSection';
import WhyChooseSection from './components/WhyChooseSection';
import ContactSection from './components/ContactSection';
import FooterSection from './components/FooterSection';

const SurfaceSolutionsCTPage = () => (
  <div className="bg-[#060606] min-h-screen" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
    {/* 1. Header */}
    <Navbar />

    {/* 2. Main image */}
    <HeroSection />

    {/* 3. Which system is right for you */}
    <HowToChooseSection />

    {/* 4. The Complete Product Catalog */}
    <ProductShowcase onCategoryVisible={() => {}} />

    {/* 5. Built Different. Performs Different. */}
    <TechSection />

    {/* 6. Industries & Surfaces We Serve */}
    <MarketsSection />

    {/* 7. Why Choose Surface Solutions of CT */}
    <WhyChooseSection />

    {/* 8. Request Product Information */}
    <ContactSection />

    {/* 9. Footer */}
    <FooterSection />
  </div>
);

export default SurfaceSolutionsCTPage;
